// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonial-block {
    display: flex;
    flex-direction: row;
    max-width: 100%;
    height: 75vh;
    padding: 40px 75px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: #333;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.testimonial-left, .testimonial-right {
    width: 50%;
    padding: 20px;
}

.testimonial-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.testimonial-left h3{
    color: #694BF5;
    font-family: 'Figtree';
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 30px;
}

.testimonial-left h2 {
    font-family: 'Urbanist-Bold';
    font-size: 39px;
    color: #2E2E4D;
    font-weight: 700;
    margin-bottom: 20px;
}

.testimonial-left p {
    font-family: 'Figtree';
    font-size: 20px;
    color: #62636a;
    margin-bottom: 30px;
    line-height: 1.6;
}

.testimonial-btn {
    max-width: 35% ;
    font-family: 'Figtree';
    font-size: 20px;
    display: inline-block;
    font-size: 16px;
    color: #694BF5;
    text-decoration: none;
    border: 1px solid #694BF5;
    padding: 10px 20px;
    border-radius: 5px;
    transition: all 0.3s ease;
}

.testimonial-btn:hover {
    background-color: #694BF5;
    color: #fff;
}

.testimonial-btn i{
    margin-left: 8px;
}
.testimonial-right {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    max-width: 550px;
    max-height: 500px;
    margin-left: 25px;
}

.testimonial-content {
    text-align: center;
}

.testimonial-content p {
    font-family: 'Figtree';
    font-size: 16px;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.6;
}

.testimonial-author {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.testimonial-author img {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    object-fit: cover;
    margin-bottom: 10px;
}

.testimonial-author p {
    font-family: 'Figtree';
    font-weight: 700;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

/* Responsive Styles */
@media (max-width: 1024px) {
    .testimonial-block {
        padding: 10px;
        height: auto;
    }

    .testimonial-left h2 {
        font-size: 28px;
    }

    .testimonial-left h3{
        text-align: center;
    }

    .testimonial-left p {
        font-size: 16px;
    }

    .testimonial-right {
        padding: 15px;
    }
}

@media (max-width: 768px) {
    .testimonial-left, .testimonial-right {
        width: 100%;
    }

    .testimonial-block {
        flex-direction: column;
    }

    .testimonial-left h3{
        text-align: center;
    }

    .testimonial-left h2 {
        font-size: 24px;
        text-align: center;
    }

    .testimonial-left p {
        text-align: center;
        padding: 25px;
        text-align: center;
    }

    .testimonial-right {
        height: auto;
        max-width: 85%;
        margin-top: 20px;
        margin-left: 0px;
        margin: 0 auto;
    }

    .testimonial-btn {
        max-width: 75%;
        text-align: center;
        margin: 0 auto;
    }
}

@media (max-width: 480px) {
    .testimonial-left h3 {
        font-size: 20px;
        text-align: center;
    }

    .testimonial-left p {
        font-size: 14px;
    }

    .testimonial-content p {
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./assets/src/testimonial/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".testimonial-block {\r\n    display: flex;\r\n    flex-direction: row;\r\n    max-width: 100%;\r\n    height: 75vh;\r\n    padding: 40px 75px;\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    color: #333;\r\n    border-radius: 10px;\r\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.testimonial-left, .testimonial-right {\r\n    width: 50%;\r\n    padding: 20px;\r\n}\r\n\r\n.testimonial-left {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.testimonial-left h3{\r\n    color: #694BF5;\r\n    font-family: 'Figtree';\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.testimonial-left h2 {\r\n    font-family: 'Urbanist-Bold';\r\n    font-size: 39px;\r\n    color: #2E2E4D;\r\n    font-weight: 700;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.testimonial-left p {\r\n    font-family: 'Figtree';\r\n    font-size: 20px;\r\n    color: #62636a;\r\n    margin-bottom: 30px;\r\n    line-height: 1.6;\r\n}\r\n\r\n.testimonial-btn {\r\n    max-width: 35% ;\r\n    font-family: 'Figtree';\r\n    font-size: 20px;\r\n    display: inline-block;\r\n    font-size: 16px;\r\n    color: #694BF5;\r\n    text-decoration: none;\r\n    border: 1px solid #694BF5;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.testimonial-btn:hover {\r\n    background-color: #694BF5;\r\n    color: #fff;\r\n}\r\n\r\n.testimonial-btn i{\r\n    margin-left: 8px;\r\n}\r\n.testimonial-right {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #fff;\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\r\n    max-width: 550px;\r\n    max-height: 500px;\r\n    margin-left: 25px;\r\n}\r\n\r\n.testimonial-content {\r\n    text-align: center;\r\n}\r\n\r\n.testimonial-content p {\r\n    font-family: 'Figtree';\r\n    font-size: 16px;\r\n    color: #333;\r\n    margin-bottom: 20px;\r\n    line-height: 1.6;\r\n}\r\n\r\n.testimonial-author {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.testimonial-author img {\r\n    border-radius: 50%;\r\n    width: 60px;\r\n    height: 60px;\r\n    object-fit: cover;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.testimonial-author p {\r\n    font-family: 'Figtree';\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n/* Responsive Styles */\r\n@media (max-width: 1024px) {\r\n    .testimonial-block {\r\n        padding: 10px;\r\n        height: auto;\r\n    }\r\n\r\n    .testimonial-left h2 {\r\n        font-size: 28px;\r\n    }\r\n\r\n    .testimonial-left h3{\r\n        text-align: center;\r\n    }\r\n\r\n    .testimonial-left p {\r\n        font-size: 16px;\r\n    }\r\n\r\n    .testimonial-right {\r\n        padding: 15px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .testimonial-left, .testimonial-right {\r\n        width: 100%;\r\n    }\r\n\r\n    .testimonial-block {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .testimonial-left h3{\r\n        text-align: center;\r\n    }\r\n\r\n    .testimonial-left h2 {\r\n        font-size: 24px;\r\n        text-align: center;\r\n    }\r\n\r\n    .testimonial-left p {\r\n        text-align: center;\r\n        padding: 25px;\r\n        text-align: center;\r\n    }\r\n\r\n    .testimonial-right {\r\n        height: auto;\r\n        max-width: 85%;\r\n        margin-top: 20px;\r\n        margin-left: 0px;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .testimonial-btn {\r\n        max-width: 75%;\r\n        text-align: center;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .testimonial-left h3 {\r\n        font-size: 20px;\r\n        text-align: center;\r\n    }\r\n\r\n    .testimonial-left p {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .testimonial-content p {\r\n        font-size: 14px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
